import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, renderList as _renderList, createSlots as _createSlots, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cddee80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新建用户")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_sb_table = _resolveComponent("sb-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_sb_table, _mergeProps({
      listData: _ctx.dataList,
      listCount: _ctx.dataCount,
      page: _ctx.pageInfo,
      "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageInfo) = $event))
    }, _ctx.contentTableConfig), _createSlots({
      headerHandler: _withCtx(() => [
        (_ctx.isCreate)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _ctx.handleNewClick
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      status: _withCtx((scope) => [
        _createVNode(_component_el_button, {
          plain: "",
          size: "mini",
          type: scope.row.enable ? 'success' : 'danger'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.enable ? '启用' : '禁用'), 1)
          ]),
          _: 2
        }, 1032, ["type"])
      ]),
      updateAt: _withCtx((scope) => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formatTime(scope.row.updateAt)), 1)
      ]),
      createAt: _withCtx((scope) => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formatTime(scope.row.createAt)), 1)
      ]),
      handler: _withCtx((scope) => [
        _createVNode(_component_el_button, {
          icon: "el-icon-edit",
          type: "text",
          size: "mini",
          onClick: ($event: any) => (_ctx.handleEditClick(scope.row))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 2
        }, 1032, ["onClick"]),
        _createVNode(_component_el_button, {
          icon: "el-icon-delete",
          type: "text",
          size: "mini",
          onClick: ($event: any) => (_ctx.handleDeleteClick(scope.row))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 2
    }, [
      _renderList(_ctx.otherPropSlots, (item) => {
        return {
          name: item.slotName,
          fn: _withCtx((scope) => [
            (item.slotName)
              ? _renderSlot(_ctx.$slots, item.slotName, {
                  key: 0,
                  row: scope.row
                }, undefined, true)
              : _createCommentVNode("", true)
          ])
        }
      })
    ]), 1040, ["listData", "listCount", "page"])
  ]))
}